module.exports = __webpack_public_path__ + "static/scale-model-of-fresno-california-617ea7176c21a0f78bc61c38597431e5.png";